import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Slot } from "../Slot/Slot";
import styles from "./SingleColumnWithControls.module.scss";
import classNames from "classnames/bind";
import useRouteLoading from "../../hooks/useRouteLoading";

import { useInView } from "react-intersection-observer";

const cx = classNames.bind(styles);

export const slotNameMap = {
  HEADER: "header",
  BANNER: "banner",
  TOP: "top",
  ACCESSORY: "accessory",
  MAIN_TOP: "main-top",
  STICKY_BAR: "sticky-bar",
  PRE_MAIN: "pre-main",
  MAIN: "main",
  FOOTER: "footer",
} as const;

export function SingleColumnWithControls(props: PageProps) {
  const isRouteLoading = useRouteLoading();
  const { ref: stickySentinelRef, inView: stickySentinelInView } = useInView({
    initialInView: true,
  });

  const isWideFlagOn = props?.flags?.isWideFlagOn?.value;

  return (
    <div data-layout="SingleColumnWithControls" className={styles.page}>
      <Slot {...props} name={slotNameMap["HEADER"]} />

      <main className={styles.main} id="main">
        {isWideFlagOn && <Slot {...props} name={slotNameMap["BANNER"]} />}
        <div className={styles.topPanel}>
          <div
            className={cx("pageContainer", "pageContainer--top", {
              "jl-plp-prevent-wide": !isWideFlagOn,
            })}
          >
            <div className={cx("grid", "grid--top")}>
              {!isWideFlagOn && (
                <Slot
                  {...props}
                  name={slotNameMap["BANNER"]}
                  className={styles.banner}
                />
              )}
              <Slot
                {...props}
                name={slotNameMap["TOP"]}
                className={styles.top}
              />

              <Slot
                {...props}
                name={slotNameMap["MAIN_TOP"]}
                className={styles.mainTop}
              />
            </div>
          </div>
        </div>

        <div ref={stickySentinelRef} className={styles.stickySentinel} />
        <div
          className={cx("stickyContainer", {
            isStuck: !stickySentinelInView,
            "u-loading": isRouteLoading,
          })}
        >
          <div
            className={cx("pageContainer", {
              "jl-plp-prevent-wide": !isWideFlagOn,
            })}
          >
            <div className={styles.grid}>
              <Slot
                {...props}
                name={slotNameMap["STICKY_BAR"]}
                className={cx("stickyBar", {
                  isStuck: !stickySentinelInView,
                })}
              />
            </div>
          </div>
        </div>

        <div
          className={cx("pageContainer", {
            "jl-plp-prevent-wide": !isWideFlagOn,
          })}
        >
          <div className={styles.grid}>
            <div className={styles.content}>
              <Slot {...props} name={slotNameMap["PRE_MAIN"]} />
              <Slot
                {...props}
                name={slotNameMap["MAIN"]}
                className={cx("mainSlot", {
                  "u-loading": isRouteLoading,
                })}
              />
            </div>
          </div>
        </div>
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} />
    </div>
  );
}
